/**
 * @description
 * Exposes APIs for error handling.
 */
class ErrorHandler {
  public genericFailedMessage: string;

  constructor() {
    this.genericFailedMessage = 'Failed to display content. Contact the application administrator.';
  }

  /**
   * Returns the generic failure message
   * @description This exposes the method to return the generic failure message
   *
   * @example <caption>Example for getGenericFailedMessage()</caption>
   * Example usage -
   * PCore.getErrorHandler().getGenericFailedMessage();
   * @returns the failure message string
   * @function
   */

  getGenericFailedMessage() {
    return this.genericFailedMessage;
  }

  /**
   * sets the generic failure message
   * @description This exposes the method to set the generic failure message
   *
   * @example <caption>Example for setGenericFailedMessage()</caption>
   * Example usage -
   * PCore.getErrorHandler().setGenericFailedMessage('Failed to load preview');
   * @function
   */

  setGenericFailedMessage(message: string) {
    this.genericFailedMessage = message;
  }
}

export default new ErrorHandler();
